<div> 
  <app-seminovos-filtro
        [filtros]="filtros">
  </app-seminovos-filtro>
  <app-seminovos-lista
        [filtros]="filtros"
        (definirFiltro)="definirFiltro()"
        (exibir)="selecionar($event)">
  </app-seminovos-lista>
 </div>